import type React from 'react';

export function AnimatedDigit({ char, height = 38 }: { char: string; height?: number }) {
  const digits = '0123456789';
  const idx = digits.indexOf(char);
  if (idx === -1) return <span style={{ display: 'inline-block', textAlign: 'center' }}>{char}</span>;
  return (
    <span className="digit-slot" style={{ height, lineHeight: `${height}px`, textAlign: 'center' }}>
      <span className="digit-slot-inner block" style={{ transform: `translateY(-${idx * height}px)` }}>
        {digits.split('').map(d => (
          <span key={d} className="block" style={{ height, lineHeight: `${height}px` }}>{d}</span>
        ))}
      </span>
    </span>
  );
}

export function AnimatedNumber({
  value,
  height = 38,
  className = '',
  style = {},
}: {
  value: string;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <span className={className} style={{ display: 'inline-flex', fontVariantNumeric: 'tabular-nums', ...style }}>
      {value.split('').map((ch, i) => (
        <AnimatedDigit key={i} char={ch} height={height} />
      ))}
    </span>
  );
}
